import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export default function DynamicLinkRedirect() {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const srcId = searchParams.get('src_id');

  useEffect(() => {
    if (code) {
      // Build the backend URL with query params if present
      let url = `${BACKEND_URL}/api/link/${code}`;
      if (srcId) {
        url += `?src_id=${srcId}`;
      }

      // Redirect the browser directly to the backend endpoint
      // The backend will handle tracking and redirection
      // If the link doesn't exist, backend will return 404
      window.location.href = url;
    }
  }, [code, srcId]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-navy mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
